import React from 'react';

type Props = {
    description?: string | null;
    /** Perkecil teks (dipakai di folio/invoice). */
    small?: boolean;
    className?: string;
};

/**
 * Rincian item & pajak sebuah extra (mis. bill dari POS).
 *
 * Isinya sudah diformat rapi sebagai teks kolom oleh API, jadi harus
 * dirender monospace dengan `white-space: pre` — kalau tidak, perataan
 * angkanya rusak dan tamu sulit mencocokkan dengan struk.
 */
const ExtraDescription: React.FC<Props> = ({ description, small = false, className = '' }) => {
    if (!description?.trim()) return null;

    return (
        <pre
            className={`mb-0 text-muted ${className}`}
            style={{
                fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
                fontSize: small ? '0.7rem' : '0.75rem',
                lineHeight: 1.45,
                whiteSpace: 'pre',
                overflowX: 'auto',
                background: 'transparent',
                border: 0,
                padding: 0,
                margin: 0,
            }}
        >
            {description}
        </pre>
    );
};

export default ExtraDescription;
